import React, { useRef, useState } from "react";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, TextField } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { ApprovalWorkflowDialogWrapper } from "../ViewRequest/ApprovalWorkflowDialogStyled";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getQuoteDetails,
  getQuoteHistory,
  getSAMLeadership,
  saveNote,
  saveQuoteHistory,
} from "../../Actions/QuoteAction";
import {
  LocalStorageKeys,
  QuoteStatus,
  UserRole,
} from "../QuoteRequest/Content";
import { Congiguration } from "../../Constants/AppConstants";
import { isJsonString } from "../../Helper/Helper";
import { GET_LOGGED_USER_DETAILS } from "../../ActionTypes/ActionTypes";
import {
  addOpportunityProduct,
  getCrmUploadData,
} from "../../Actions/CRMAction";
import { Content } from "../ViewRequest/Content";
import { Severity } from "../utilities/Notification/NotificationContent";
import { sendEmailToStakeHolders } from "../../Actions/CommonAction";
import checkIcon from "../../images/checkIcon.svg";
import Loader from "../utilities/Loader/Loader";

let quoteHistory = {
  userId: 0,
  approverId: 0,
  quoteId: "",
  statusId: 0,
  companyId: 0,
  isDiscount: false,
};
let latestQuoteHistory = {
  userId: 0,
  approverId: 0,
  quoteId: "",
  statusId: 0,
  companyId: 0,
  isDiscount: false,
  createdDate: null,
};
let emailParams = {
  emailQuoteDetails: {},
  requestorEmail: "",
  requestorFirstName: "",
  requestorLastName: "",
  approverEmail: "",
  approverFirstName: "",
  approverLastName: "",
  isDiscount: false,
};
const QuoteApprovalWorkflowDialog = ({
  show,
  handleCancelClick,
  isConfirmation,
  quoteId,
  showAlerts,
  handleClose,
}) => {
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const loggedUserLocalStorage = isJsonString(
    sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER)
  )
    ? JSON.parse(sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER))
    : null;

  let loggedUser = useSelector((state) => state?.UserReducer?.loggedUser);
  if (
    Object?.keys(loggedUser)?.length === 0 &&
    loggedUser?.constructor === Object &&
    loggedUserLocalStorage !== null
  ) {
    loggedUser = loggedUserLocalStorage;
    //storing user login to reducer
    dispatch({
      type: GET_LOGGED_USER_DETAILS,
      payload: loggedUser,
    });
  }
  const [quote, setQuote] = useState({});
  const [quoteHistoryValues, setQuoteHistoryValues] = useState({
    ...quoteHistory,
  });
  const [isDiscountExist, setIsDiscountExist] = useState(false);
  const [approver, setApprover] = useState();
  const [quoteApprovalReceivedFrom, setQuoteApprovalReceivedFrom] =
    useState(-1);
  const [latestQuoteHistoryValues, setLatestQuoteHistoryValues] = useState({
    ...latestQuoteHistory,
  });
  const [samLeadershipData, setSamLeadershipData] = useState([]);
  const [isRejectedByPricingTeam, setIsRejectedByPricingTeam] = useState(false);
  const [isConfirm, setIsConfirm] = useState(isConfirmation);
  const [approverId, setApproverId] = useState(0);
  const [dialogText, setDialogText] = useState("");
  const [approverError, setApproverError] = useState("");
  const [dialogError, setDialogError] = useState("");
  const [loadingState, setLoadingState] = useState(false);

  React.useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  });
  const [submitError, setubSubmitError] = useState("");

  useEffect(() => {
    setLoadingState(true);
    getViewRequest(quoteId);
  }, []);
  function getViewRequest(quoteId) {
    if (quoteId) {
      dispatch(getQuoteDetails(quoteId))
        .then((data) => {
          setQuote({ ...data });
          setQuoteHistoryValues((prevValues) => ({
            ...prevValues,
            userId: loggedUser?.user?.id,
            approverId: approver,
            quoteId: data?.quoteDetails?.quoteId,
            statusId: data?.quoteDetails?.quoteStatusId,
            companyId: Congiguration?.CompanyId,
          }));
          setIsDiscountExist(data?.quoteDetails?.discount !== 0);
        })
        .catch((e) => {
          console.log(e);
        });

      console.log("logged user view quote", loggedUser);
    }
    //Get all quote history values

    dispatch(getQuoteHistory(quoteId))
      .then((data) => {
        if (data) {
          setLatestQuoteHistoryValues(data);
          console.log("Latest quote histories", data);
          setQuoteApprovalRecievedFromUser(data);
        }
        setLoadingState(false);
      })
      .catch((e) => {
        console.log(e);
        setLoadingState(false);
      });
  }
  function setQuoteApprovalRecievedFromUser(quoteHistories) {
    let historyStatuses = [];

    quoteHistories?.map((history) => {
      historyStatuses.push(history?.statusId);
    });

    let uniqueQuoteHistories = historyStatuses?.filter(
      (value, index, arr) => index === 0 || arr[index] !== arr[index - 1]
    );

    const counts = {};

    for (const status of uniqueQuoteHistories) {
      counts[status] = counts[status] ? counts[status] + 1 : 1;
    }

    //set if rejected by pricing team
    if (
      uniqueQuoteHistories[0] === QuoteStatus.QUOTEPENDINGSAMLEADERSHIP &&
      counts[QuoteStatus.QUOTEPENDINGSAMLEADERSHIP] > 1 &&
      uniqueQuoteHistories?.length > 3 &&
      uniqueQuoteHistories[2] !== QuoteStatus.QUOTEPENDINGINITIALREQUESTOR
    ) {
      setIsRejectedByPricingTeam(true);
    }
    // set rejected by SAM Leadership team / set rejected by Pricing team as false
    else if (
      uniqueQuoteHistories[0] === QuoteStatus.QUOTEPENDINGSAMLEADERSHIP &&
      uniqueQuoteHistories?.length >= 3 &&
      uniqueQuoteHistories[2] === QuoteStatus.QUOTEPENDINGINITIALREQUESTOR
    ) {
      setIsRejectedByPricingTeam(false);
      //set IsRejectBySAMLeadership required ?
    }

    if (
      uniqueQuoteHistories[0] === QuoteStatus.QUOTEPENDINGPRICINGTEAM &&
      uniqueQuoteHistories?.length === 1
    ) {
      setQuoteApprovalReceivedFrom(UserRole.SAMTEAM);
    } else if (
      uniqueQuoteHistories[0] === QuoteStatus.QUOTEPENDINGPRICINGTEAM &&
      uniqueQuoteHistories?.length > 1 &&
      uniqueQuoteHistories[1] === QuoteStatus.QUOTEPENDINGSAMLEADERSHIP
    ) {
      setQuoteApprovalReceivedFrom(UserRole.SAMLEADERSHIPTEAM);
    } else if (
      uniqueQuoteHistories[0] === QuoteStatus.QUOTEPENDINGPRICINGTEAM &&
      uniqueQuoteHistories?.length > 1 &&
      uniqueQuoteHistories[1] === QuoteStatus.QUOTEPENDINGINITIALREQUESTOR
    ) {
      setQuoteApprovalReceivedFrom(UserRole.SAMTEAM);
    } else if (
      uniqueQuoteHistories[0] === QuoteStatus.QUOTEPENDINGSAMLEADERSHIP
    ) {
      setQuoteApprovalReceivedFrom(UserRole.PRICINGTEAM);
    } else if (
      uniqueQuoteHistories[0] === QuoteStatus.QUOTEPENDINGPRICINGTEAM &&
      uniqueQuoteHistories?.length > 1 &&
      uniqueQuoteHistories[1] === QuoteStatus.SAVEASDRAFT
    ) {
      setQuoteApprovalReceivedFrom(UserRole.SAMTEAM);
    } else if (
      uniqueQuoteHistories[0] === QuoteStatus.QUOTEAPPROVED ||
      uniqueQuoteHistories[0] === QuoteStatus.CONTRACTED ||
      uniqueQuoteHistories[0] ===
        QuoteStatus.CONTRACTEDRESERVATIONSMARGINCONCERNS ||
      uniqueQuoteHistories[0] ===
        QuoteStatus.CONTRACTEDRESERVATIONSCONTRACTEDTERMUTILIZATION ||
      uniqueQuoteHistories[0] ===
        QuoteStatus.CONTRACTEDRESERVATIONSMINBILLINGNOTGUARANTEED ||
      uniqueQuoteHistories[0] === QuoteStatus.QUOTECLOSED
    ) {
      setQuoteApprovalReceivedFrom(UserRole.PRICINGTEAM);
    }
  }

  const handleChange = (e) => {
    let value = e?.target?.value;
    if (typeof value === "undefined " || !value || value?.trim() === "") {
      setubSubmitError("This field is required.");
    } else {
      setubSubmitError("");
    }
    handleTextBoxChange(value);
  };

  const handleSubmit = () => {
    let validate = true;
    console.log(dialogText, "dialogtext");
    if (
      typeof dialogText === "undefined" ||
      !dialogText ||
      dialogText?.trim() === ""
    ) {
      setubSubmitError("This field is required.");
      validate = false;
    }
    if (approverId === "" || approverId === 0) {
      setApproverError("This field is required.");
      validate = false;
    }
    if (validate) {
      setubSubmitError("");
      handleConfirmClick();
    }
  };

  const handleConfirm = () => {
    if (
      loggedUser?.userRole[0]?.id === UserRole.PRICINGTEAM &&
      quoteApprovalReceivedFrom === UserRole.SAMTEAM
    ) {
      setIsConfirm(false);
    }
    handleApprovebuttonClick();
  };
  const handleApprovebuttonClick = () => {
    if (
      (quote?.quoteDetails?.quoteStatusId ===
        QuoteStatus.QUOTEPENDINGPRICINGTEAM &&
        loggedUser?.userRole[0]?.id === UserRole.PRICINGTEAM &&
        quoteApprovalReceivedFrom === UserRole.SAMLEADERSHIPTEAM) ||
      (quote?.quoteDetails?.quoteStatusId ===
        QuoteStatus.QUOTEPENDINGSAMLEADERSHIP &&
        loggedUser?.userRole[0]?.id === UserRole.SAMLEADERSHIPTEAM) ||
      (quote?.quoteDetails?.quoteStatusId ===
        QuoteStatus.QUOTEPENDINGPRICINGTEAM &&
        loggedUser?.userRole[0]?.id === UserRole.PRICINGTEAM &&
        quoteApprovalReceivedFrom === UserRole.SAMTEAM)
    ) {
      //Quote approved by SAM Leadership
      if (loggedUser?.userRole[0]?.id === UserRole.SAMLEADERSHIPTEAM) {
        let objQuoteHistory = { ...quoteHistoryValues };
        let latestObjQuoteHistory = { ...latestQuoteHistoryValues };

        objQuoteHistory.approverId = loggedUser?.user?.id;

        if (latestObjQuoteHistory[0]?.isDiscount || isRejectedByPricingTeam) {
          objQuoteHistory.statusId = QuoteStatus.QUOTEPENDINGPRICINGTEAM;
          //remove discount flag from sessionStorage
          sessionStorage.removeItem(LocalStorageKeys.ISDISCOUNTCHANGED);
          objQuoteHistory.isDiscount = false;
        } else {
          objQuoteHistory.statusId = QuoteStatus.QUOTEAPPROVED;

          //get crm upload data (crm-cpq mapped data)
          dispatch(getCrmUploadData(quote?.quoteDetails?.quoteId))
            .then((data) => {
              console.log("getCrmUploadData", data);
              //save quote to CRM
              saveOpportunityProductToCrm(data);
            })
            .catch((e) => {
              console.log("err getCrmUploadData", e);
            });
        }

        dispatch(saveQuoteHistory(objQuoteHistory))
          .then((data) => {
            console.log(data, "SAM saveQuoteHistory");
          })
          .catch((e) => {
            console.log(e);
          });

        //SendEmail
        emailParams.requestorEmail = quote?.initialRequestor?.email;
        emailParams.requestorFirstName = quote?.initialRequestor?.firstName;
        emailParams.requestorLastName = quote?.initialRequestor?.lastName;

        emailParams.emailQuoteDetails.quoteId = quote?.quoteDetails?.quoteName;
        emailParams.emailQuoteDetails.product =
          quote?.quoteDetails?.productName;
        let totalHc = 0;
        quote?.countryHeadCounts?.map((countryHc) => {
          totalHc += countryHc?.headcount;
        });
        emailParams.emailQuoteDetails.headCount = totalHc;
        emailParams.emailQuoteDetails.pricingStructure =
          quote?.quoteDetails?.pricingStructureName;
        emailParams.emailQuoteDetails.quoteStatusId = objQuoteHistory?.statusId;
        emailParams.emailQuoteDetails.accountName =
          quote?.opportunityDetails?.accountName;
        emailParams.emailQuoteDetails.opportunityName =
          quote?.opportunityDetails?.oppurtunityName;
        emailParams.emailQuoteDetails.opportunityId =
          quote?.opportunityDetails?.oppurtunity;
        emailParams.emailQuoteDetails.quoteUrl =
          Congiguration?.CPQEmailUrlBaseAddress +
          `/?QuoteId=${quote?.quoteDetails?.quoteId}`;

        let quotedRate = 0.0;
        let annualRevenue = 0.0;

        let alInPrice = {};
        if (quote?.allInPrice?.length) {
          alInPrice = { ...quote?.allInPrice[quote?.allInPrice?.length - 1] };
        }
        annualRevenue = alInPrice?.revenueStage4TotalReqCurrency;
        switch (quote?.quoteDetails?.pricingStructureId) {
          case 1:
            quotedRate = alInPrice?.ffsTotalReqCurrency;
            break;
          case 2:
            quotedRate = alInPrice?.flatFeeAnnualTotalReqCurrency;
            break;
          case 3:
            quotedRate = alInPrice?.flatFeeMonthlyTotalReqCurrency;
            break;
          case 4:
            quotedRate = alInPrice?.pepmTotalReqCurrency;
            break;
          case 5:
            quotedRate = alInPrice?.pepyTotalReqCurrency;
            break;
          default:
            quotedRate = 0.0;
            annualRevenue = 0.0;
            break;
        }

        emailParams.emailQuoteDetails.currencyCode =
          quote?.quoteDetails?.currencyCode;
        emailParams.emailQuoteDetails.quotedRate = quotedRate;
        emailParams.emailQuoteDetails.annualRevenue = annualRevenue;
        emailParams.isDiscount = false;

        emailParams.emailQuoteDetails.memberOf =
          quote?.opportunityDetails?.memberOf;
        emailParams.emailQuoteDetails.brokerName =
          quote?.opportunityDetails?.oppurtunityReferrerName;
        emailParams.emailQuoteDetails.pricingType =
          quote?.opportunityDetails?.oppurtunityType;

        const crmDataFromSession = isJsonString(
          sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL)
        )
          ? JSON.parse(sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL))
          : null;

        emailParams.emailQuoteDetails.opportunityType =
          crmDataFromSession?.opportunityType;
        emailParams.emailQuoteDetails.samMember =
          quote?.quoteDetails?.createdByName;
        emailParams.emailQuoteDetails.renewalDate =
          quote?.opportunityDetails?.oppurtunityType === "RENEWAL"
            ? quote?.opportunityDetails?.programStartDate
            : null;
        emailParams.emailQuoteDetails.deadline = quote?.quoteDetails?.deadline;
        emailParams.emailQuoteDetails.samRecommendationNotes =
          quote?.quoteDetails?.samPriceRecommendAssumption;

        dispatch(sendEmailToStakeHolders(emailParams))
          .then((data) => {
            console.log("send email sam approve", data);
          })
          .catch((e) => {
            console.log(e);
          });

        showAlerts(
          objQuoteHistory.statusId === QuoteStatus.QUOTEPENDINGPRICINGTEAM
            ? Content.APPROVETOPRICING
            : Content.APPROVESUCCESS,
          Severity.SUCCESS
        );
        handleClose();
      }
      //Quote approved by Pricing Team when received from SAM Leadership
      else if (
        loggedUser?.userRole[0]?.id === UserRole.PRICINGTEAM &&
        isDiscountExist &&
        quoteApprovalReceivedFrom === UserRole.SAMLEADERSHIPTEAM
      ) {
        let objQuoteHistory = { ...quoteHistoryValues };

        objQuoteHistory.approverId = loggedUser?.user?.id;
        objQuoteHistory.statusId = QuoteStatus.QUOTEAPPROVED;

        //get crm upload data (crm-cpq mapped data)
        dispatch(getCrmUploadData(quote?.quoteDetails?.quoteId))
          .then((data) => {
            console.log("getCrmUploadData", data);
            //save quote to CRM
            saveOpportunityProductToCrm(data);
          })
          .catch((e) => {
            console.log("err getCrmUploadData", e);
          });

        dispatch(saveQuoteHistory(objQuoteHistory))
          .then((data) => {
            console.log(data, "PT saveQuoteHistory");
          })
          .catch((e) => {
            console.log(e);
          });
        showAlerts(Content.APPROVESUCCESS, Severity.SUCCESS);
        handleClose();
      }
      //Quote approved by Pricing Team when received from SAM Team(Initial Requestor)
      else if (
        loggedUser?.userRole[0]?.id === UserRole.PRICINGTEAM &&
        quoteApprovalReceivedFrom === UserRole.SAMTEAM
      ) {
        dispatch(getSAMLeadership(UserRole.SAMLEADERSHIPTEAM))
          .then((data) => {
            console.log(data, "SAM Leaderdhip data");
            setSamLeadershipData([...data]);
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        showAlerts(
          "you don't have access to approve the quote",
          Severity.WARNING
        );
        handleClose();
        console.log("you dont't have access to approve the quote");
      }
    } else {
      showAlerts(
        "you don't have access to approve the quote",
        Severity.WARNING
      );
      handleClose();
      console.log("you dont't have access to approve the quote");
    }
  };

  function saveOpportunityProductToCrm(opportunityProduct) {
    const populationDetails = opportunityProduct?.crmCountryHeadCount?.map(
      (item) => {
        return {
          countryId: item?.crmCountryId,
          country: item?.countryName,
          headCount: item?.headcount,
          region: item?.region,
        };
      }
    );

    const components = opportunityProduct?.listCrmComponent?.map((comp) => {
      return {
        name: comp?.componentName,
        componentId: comp?.crmComponentId,
      };
    });

    const opportunityProductToSave = {
      opportunitId: opportunityProduct?.crmQuote?.oppurtunityId,
      productId: opportunityProduct?.crmQuote?.crmProductId,
      session: opportunityProduct?.crmQuote?.sessions,
      hours: opportunityProduct?.crmQuote?.hours,
      utilization: opportunityProduct?.crmQuote?.utilization,
      rate: opportunityProduct?.crmQuote?.rate,
      pricingStrucutre: `${opportunityProduct?.crmQuote?.pricingStructureCode}`,
      quoteId: opportunityProduct?.crmQuote?.quoteId,
      currencyId: opportunityProduct?.crmQuote?.currencyCode,
      seatCount: opportunityProduct?.crmQuote?.seatCount,
      populations: [...populationDetails],
      componentList: [...components],
    };

    //Save quote details to CRM
    dispatch(addOpportunityProduct(opportunityProductToSave))
      .then((data) => {
        console.log("add opporunity product to CRM", data);
      })
      .catch((e) => {
        console.log("err add opportunity product", e);
      });
  }
  const handleConfirmClick = () => {
    let validate = false;
    if (approverId === 0) {
      setApproverError(Content.REQUIREDERROR);
      validate = true;
    }
    if (dialogText === "") {
      setDialogError(Content.REQUIREDERROR);
      validate = true;
    }
    if (validate) {
      return false;
    }
    if (quoteHistoryValues) {
      dispatch(saveQuoteHistory(quoteHistoryValues))
        .then((data) => {
          console.log(data, "saveQuoteHistory");
        })
        .catch((e) => {
          console.log(e);
        });

      if (dialogText) {
        let newNote = {
          message: dialogText,
          companyId: Congiguration?.companyId,
          userId: loggedUser?.user?.id,
          quoteId: quote?.quoteDetails?.quoteId,
        };
        dispatch(saveNote(newNote))
          .then((data) => {
            console.log(newNote, "saveNote");
          })
          .catch((e) => {
            console.log(e);
          });
        setDialogText("");
      }

      //SendEmail
      emailParams.requestorEmail = loggedUser?.user?.email;
      emailParams.requestorFirstName = loggedUser?.user?.firstName;
      emailParams.requestorLastName = loggedUser?.user?.lastName;

      //TODO
      //Get SAM Leadership details
      const allSamLeadershipUsers = [...samLeadershipData];
      const samLeadershipUser = allSamLeadershipUsers?.filter(
        (user) => user?.userId === approverId
      );

      emailParams.approverEmail = samLeadershipUser[0]?.email;
      emailParams.approverFirstName = samLeadershipUser[0]?.firstName;
      emailParams.approverLastName = samLeadershipUser[0]?.lastName;

      emailParams.emailQuoteDetails.quoteId = quote?.quoteDetails?.quoteName;
      emailParams.emailQuoteDetails.product = quote?.quoteDetails?.productName;
      let totalHc = 0;
      quote?.countryHeadCounts?.map((countryHc) => {
        totalHc += countryHc?.headcount;
      });
      emailParams.emailQuoteDetails.headCount = totalHc;
      emailParams.emailQuoteDetails.pricingStructure =
        quote?.quoteDetails?.pricingStructureName;
      emailParams.emailQuoteDetails.quoteStatusId =
        quoteHistoryValues?.statusId;
      emailParams.emailQuoteDetails.accountName =
        quote?.opportunityDetails?.accountName;
      emailParams.emailQuoteDetails.opportunityName =
        quote?.opportunityDetails?.oppurtunityName;
      emailParams.emailQuoteDetails.opportunityId =
        quote?.opportunityDetails?.oppurtunity;
      emailParams.emailQuoteDetails.quoteUrl =
        Congiguration?.CPQEmailUrlBaseAddress +
        `/?QuoteId=${quote?.quoteDetails?.quoteId}`;

      let quotedRate = 0.0;
      let annualRevenue = 0.0;

      let alInPrice = {};
      if (quote?.allInPrice?.length) {
        alInPrice = { ...quote?.allInPrice[quote?.allInPrice?.length - 1] };
      }

      annualRevenue = alInPrice?.revenueStage4TotalReqCurrency;
      switch (quote?.quoteDetails?.pricingStructureId) {
        case 1:
          quotedRate = alInPrice?.ffsTotalReqCurrency;
          break;
        case 2:
          quotedRate = alInPrice?.flatFeeAnnualTotalReqCurrency;
          break;
        case 3:
          quotedRate = alInPrice?.flatFeeMonthlyTotalReqCurrency;
          break;
        case 4:
          quotedRate = alInPrice?.pepmTotalReqCurrency;
          break;
        case 5:
          quotedRate = alInPrice?.pepyTotalReqCurrency;
          break;
        default:
          quotedRate = 0.0;
          annualRevenue = 0.0;
          break;
      }

      emailParams.emailQuoteDetails.currencyCode =
        quote?.quoteDetails?.currencyCode;
      emailParams.emailQuoteDetails.quotedRate = quotedRate;
      emailParams.emailQuoteDetails.annualRevenue = annualRevenue;
      emailParams.isDiscount = false;

      emailParams.emailQuoteDetails.memberOf =
        quote?.opportunityDetails?.memberOf;
      emailParams.emailQuoteDetails.brokerName =
        quote?.opportunityDetails?.oppurtunityReferrerName;
      emailParams.emailQuoteDetails.pricingType =
        quote?.opportunityDetails?.oppurtunityType;

      const crmDataFromSession = isJsonString(
        sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL)
      )
        ? JSON.parse(sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL))
        : null;

      emailParams.emailQuoteDetails.opportunityType =
        crmDataFromSession?.opportunityType;
      emailParams.emailQuoteDetails.samMember =
        quote?.quoteDetails?.createdByName;
      emailParams.emailQuoteDetails.renewalDate =
        quote?.opportunityDetails?.oppurtunityType === "RENEWAL"
          ? quote?.opportunityDetails?.programStartDate
          : null;
      emailParams.emailQuoteDetails.deadline = quote?.quoteDetails?.deadline;
      emailParams.emailQuoteDetails.samRecommendationNotes =
        quote?.quoteDetails?.samPriceRecommendAssumption;

      dispatch(sendEmailToStakeHolders(emailParams))
        .then((data) => {
          console.log("send email", data);
        })
        .catch((e) => {
          console.log(e);
        });
    }
    showAlerts("Quote Approval succes", Severity.SUCCESS);
    handleClose();
  };
  const handleSelectChange = (event) => {
    const { name, value } = event?.target;
    setApproverError("");
    setApproverId(value);
    console.log("approverId", value);
    setQuoteHistoryValues((prevValues) => ({
      ...prevValues,
      approverId: value,
      statusId: QuoteStatus.QUOTEPENDINGSAMLEADERSHIP,
    }));
  };

  const handleTextBoxChange = (value) => {
    if (value) {
      setDialogText(value);
    } else {
      setDialogText("");
    }
  };
  return (
    <div>
      <ApprovalWorkflowDialogWrapper
        open={show}
        onClose={handleCancelClick}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        scroll="paper"
        maxWidth="xs"
        fullWidth={true}
      >
        {isConfirm && (
          <>
            <DialogTitle id="alert-dialog-title" className="customDialogTitle">
              <>Confirm</>
            </DialogTitle>
            <DialogContent className="confirmationTextForVis">
              <DialogContentText
                id="alert-dialog-description"
                className="customDialog"
              >
                Would you like to proceed with the approval?
              </DialogContentText>
            </DialogContent>
            <DialogActions className="confirmationButtonBox">
              <Button
                variant="outlined"
                className="rightButton"
                onClick={handleCancelClick}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className="confirmButton"
                onClick={handleConfirm}
              >
                Approve
              </Button>
            </DialogActions>
          </>
        )}
        {!isConfirm && (
          <>
            <DialogTitle id="alert-dialog-title" className="customDialogTitle">
              <>Approve</>
            </DialogTitle>
            <DialogContent>
              <DialogContentText
                id="alert-dialog-description"
                className="customDialog"
              >
                <div>
                  <div>
                    <img src={checkIcon} alt="img" />
                  </div>
                  <div>{Content.APPROVEHEADING}</div>
                  <div className="inputform">
                    <TextField
                      className="formValue"
                      onChange={handleChange}
                      placeholder="Any comments? Please type here."
                      multiline
                      rows={4}
                      name="note"
                    />
                    <Box className="errorBox">
                      {submitError && (
                        <span className="error">{submitError}</span>
                      )}
                    </Box>
                  </div>
                  <div>
                    <FormControl className="customDropdown">
                      <Select
                        defaultValue={0}
                        onChange={handleSelectChange}
                        size="small"
                      >
                        <MenuItem disabled value={0}>
                          Select Approver
                        </MenuItem>
                        {samLeadershipData?.map((option) => (
                          <MenuItem key={option?.userId} value={option?.userId}>
                            {option?.lastName + "," + option?.firstName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <Box className="errorBox">
                      {approverError && (
                        <span className="error">{approverError}</span>
                      )}
                    </Box>
                  </div>
                </div>
              </DialogContentText>
            </DialogContent>
            <DialogActions className="dialogbutton">
              <>
                <Button
                  variant="outlined"
                  className="rightButton"
                  onClick={handleCancelClick}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  className="confirmButton"
                  onClick={handleSubmit}
                >
                  Confirm
                </Button>
              </>
            </DialogActions>
          </>
        )}
        <Loader open={loadingState || quote?.quoteDetails === undefined} />
      </ApprovalWorkflowDialogWrapper>
    </div>
  );
};

export default QuoteApprovalWorkflowDialog;
